<script lang="ts">

export let data: any[] = [];

let className = "table";
export { className as class };

</script>

<table class={className}>
	<thead>
		<slot name="thead">
			<tr>
				<td colspan="100" class="bg-warning">
					<p class="mb-0">
						<strong>Warning:</strong> Missing table header.<br>
						Example: <code>{`<tr slot="thead"><th>Column name</th><th>...</th></tr>`}</code>
					</p>
				</td>
			</tr>
		</slot>
	</thead>
	<tbody>
		{#each data as item}
			<slot name="tbody" {item}>
				<tr>
					<td colspan="100" class="bg-warning">
						<p class="mb-0">
							<strong>Warning:</strong> Missing table body.<br>
							Example: <code>{`<tr slot="tbody" let:item={item}><td>{item}</td><td>...</td></tr>`}</code>
						</p>
					</td>
				</tr>
			</slot>
		{:else}
			<slot name="noData">
				<tr>
					<td colspan="100">No result</td>
				</tr>
			</slot>
		{/each}
	</tbody>
	<tfoot>
		<slot name="tfoot"></slot>
	</tfoot>
</table>
